//import React from "react";
import { useGlobal } from "reactn";
import cx from "classnames";
import useLanguage from "../useLanguage";

import RentalTypeDropdown from "./RentalTypeDropdown";

const RentalTypeSelect = ({ labelText = "Rental Unit Type" }) => {
  const [lang] = useGlobal("LANGUAGE");
  const [showRental] = useGlobal("SHOW_RENTAL"); // this is set by Province, not by avaiable product
  const [hasRental] = useGlobal("PROD_AVAIL_RENTAL_VAL");
  const [readonly] = useGlobal("READONLY_PREFILL");

  const { t } = useLanguage();

  //-------------------------------------------
  if (readonly || !hasRental || !showRental) return null;
  //-------------------------------------------

  return (
    <div className="rental-select table">
      <div className="table-row">
        <span className={cx("feature-label", "table-cell", lang)} title={t(labelText)}>
          {t(labelText)}
        </span>
        <span className="table-cell">
          <RentalTypeDropdown autoFill={true} />
        </span>
      </div>
    </div>
  );
};

export default RentalTypeSelect;
